import React, { forwardRef, useState, useEffect } from 'react'
import { Input, Textarea, Cascader } from '@ow/comps'
import { useDitto } from '@ow/ditto-core'
import { listToTree } from '@ow/utils'

const Render = function ({ opts = {}, onChange, onBlur, value, style }, ref) {
  const { rangeSetting, minlen, maxlen, remote = {} } = opts
  const { onFetchRemoteData } = useDitto()
  const [options, setOptions] = useState([])
  const [inputLength, setInputLength] = useState((value && value.length) || 0)
  const onTextChange = (e) => {
    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: e.target.value.trim() } })
    }
    setInputLength(e.target.value.trim().length)
  }

  useEffect(() => {
    if (onFetchRemoteData && remote && remote.api) {
      // 如果配置了api,走extend请求定制接口
      if (remote && remote.api) {
        const extend = onFetchRemoteData('extend')

        extend[remote.api](remote.url, remote.opts).then((res) => {
          if (res) {
            setOptions(
              listToTree(
                (res || []).map((option) => {
                  return { ...option, label: option.title }
                })
              )
            )
          }
        })
      }
    }
  }, [])

  return (
    <div className="relative flex flex-row items-center w-full" ref={ref}>
      {opts.render === 'cascader' ? (
        <Cascader
          tree={options}
          inputStyle={{
            height: '34px',
            width: '100%',
            ...style,
          }}
          placeholder={opts.hint || `请选择${opts.title}`}
          inputClassName="right-input"
          fieldNames={{
            label: 'title',
            value: 'title',
            children: 'children',
          }}
          allowClear={false}
          onChange={(selectedKeys) => {
            onChange(selectedKeys)
          }}
          value={value || undefined}
          notFoundContent="暂无数据"
        />
      ) : (
        <>
          {opts.render === 'text' ? (
            <Textarea
              className="flex-1"
              // autoComplete="off"
              style={{
                paddingLeft: '0.75rem',
                paddingRight: '0.75rem',
                fontSize: '0.8125rem',
                width: '100%',
                ...style,
              }}
              defaultValue={value}
              value={value}
              name={opts.slug}
              onChange={onTextChange}
              onBlur={onBlur}
              rows="3"
              readonly={opts.readonly}
              disabled={opts.onlyShow}
              placeholder={opts.hint || opts.intro}
              maxLength={rangeSetting && maxlen}
              minLength={rangeSetting && minlen}
              // ref={ref}
            />
          ) : (
            <Input
              name={opts.slug}
              autoComplete="off"
              className="flex-1"
              style={{
                paddingLeft: '0.75rem',
                paddingRight: '0.75rem',
                fontSize: '0.8125rem',
                width: '100%',
                ...style,
              }}
              onChange={onTextChange}
              onBlur={onBlur}
              defaultValue={value}
              value={value}
              readonly={opts.readonly}
              disabled={opts.onlyShow}
              placeholder={opts.hint || opts.intro}
              maxLength={rangeSetting && maxlen}
              minLength={rangeSetting && minlen}
              // ref={ref}
            />
          )}
          {opts.rangeSetting && (
            <span
              className="absolute right-2 bottom-1.5"
              style={{ color: 'rgba(0,0,0,0.25)', fontSize: '0.875rem' }}
            >
              {inputLength}/{opts.maxlen}
            </span>
          )}
        </>
      )}
    </div>
  )
}

export default forwardRef(Render)
